import React, { useEffect, useState } from "react";
import AppModal from "./AppModal";

// A dialog that asks for a name, like the app's "Enter … Name" and Edit
// screens. Fields that go with the name, such as the floor a new room goes on,
// come in as children above it; disabled holds the button back until they're
// ready. onSubmit gets the trimmed name.
const NameDialog = ({
  open,
  idPrefix,
  title,
  label,
  initial = "",
  submitLabel = "Add",
  busy = false,
  disabled = false,
  onClose,
  onSubmit,
  children,
}) => {
  const [name, setName] = useState(initial);

  useEffect(() => {
    if (open) setName(initial);
  }, [open, initial]);

  const value = name.trim();
  const submit = (event) => {
    event.preventDefault();
    if (value && !busy && !disabled) onSubmit(value);
  };

  return (
    <AppModal
      open={open}
      onClose={onClose}
      title={title}
      actions={
        <>
          <button type="button" className="hx-btn is-ghost" onClick={onClose}>
            Cancel
          </button>
          <button type="submit" form={`${idPrefix}-form`} className="hx-btn" disabled={busy || disabled || !value}>
            {busy ? "Saving…" : submitLabel}
          </button>
        </>
      }
    >
      <form id={`${idPrefix}-form`} className="hx-name-form" onSubmit={submit} noValidate>
        {children}
        <label className="hx-label" htmlFor={`${idPrefix}-name`}>
          {label}
        </label>
        <input
          id={`${idPrefix}-name`}
          className="hx-input"
          value={name}
          maxLength={40}
          autoComplete="off"
          onChange={(event) => setName(event.target.value)}
        />
      </form>
    </AppModal>
  );
};

export default NameDialog;
